import { Box, Link, styled } from '@mui/material';

export const SocialNetworkContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  marginTop: '32px',
  marginLeft: '20px',
  [theme.breakpoints.up('lg')]: {
    marginLeft: '54px',
  },
}));

export const IconStyled = styled(Link, {
  shouldForwardProp: (prop) => prop !== 'hasMarginRight',
})(({ theme, hasMarginRight }) => ({
  color: theme.palette.colors.footerBackground,
  width: '23px',
  height: '23px',
  borderRadius: '50%',
  backgroundColor: theme.palette.colors.iconsOnFooterBackground,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '12px',
  marginRight: hasMarginRight && '10px',
  padding: '5px 6px',
}));
